import {checkError, closeAlert, receiveErrorAlert} from "../commonsActions";
import {getLoanSummaryProps} from "../../helpers/loanSummaryPropertyService";

export const FETCH_LOAN_SUMMARY_PROPS_BEGIN = 'FETCH_LOAN_SUMMARY_PROPS_BEGIN';
export const FETCH_LOAN_SUMMARY_PROPS_SUCCESS = 'FETCH_LOAN_SUMMARY_PROPS_SUCCESS';
export const FETCH_LOAN_SUMMARY_PROPS_ERROR = 'FETCH_LOAN_SUMMARY_PROPS_ERROR';

const fetchLoanSummaryPropsSuccess = res => ({
    type: FETCH_LOAN_SUMMARY_PROPS_SUCCESS,
    payload: {
        loanSummaryProps: res,
    }
});

const fetchLoanSummaryPropsError = error => ({
    type: FETCH_LOAN_SUMMARY_PROPS_ERROR,
    payload: {
        error: error,
    }
});

export const fetchLoanSummaryProps = retailerId => dispatch => {
    dispatch({type: FETCH_LOAN_SUMMARY_PROPS_BEGIN});

    return getLoanSummaryProps(retailerId).then(res => {
        dispatch(fetchLoanSummaryPropsSuccess(res));
        return res;
    }, error => {
        dispatch(fetchLoanSummaryPropsError(error))
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    });
};


// WEBPACK FOOTER //
// ./src/actions/loan/loanSummaryPropertyActions.js